var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_SettlementNotice"),
        width: "740px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "details-view settlement-notice"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
          _c("div", { staticStyle: { width: "100%" } }, [
            _c(
              "div",
              { staticClass: "form-row" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      "label-position": "left",
                      inline: true,
                      "label-width": "75px"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("CargoMsg.Cargo_BranchCMP") } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "200px" },
                            attrs: { "allow-create": true, no: "1" },
                            model: {
                              value: _vm.filter.officeId,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "officeId", $$v)
                              },
                              expression: "filter.officeId"
                            }
                          },
                          _vm._l(_vm.officeAmounts, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.officeChineseName,
                                value: item.officeId
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c("el-checkbox", {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_OceanFreight"),
                        no: "2"
                      },
                      model: {
                        value: _vm.filter.se,
                        callback: function($$v) {
                          _vm.$set(_vm.filter, "se", $$v)
                        },
                        expression: "filter.se"
                      }
                    }),
                    _c("el-checkbox", {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_Air"), no: "3" },
                      model: {
                        value: _vm.filter.ae,
                        callback: function($$v) {
                          _vm.$set(_vm.filter, "ae", $$v)
                        },
                        expression: "filter.ae"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "config-module": "410015206",
                "grid-params": _vm.gridParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                },
                gridReady: _vm.onGridReady
              }
            })
          ],
          1
        )
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "4" },
              on: { click: _vm.preViewClickHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PreviewEmailContent")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "5" },
              on: { click: _vm.sendOfficeClickHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SendToBranchCompany")))]
          ),
          _c("el-button", { attrs: { no: "6" }, on: { click: _vm.onCancel } }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }